import { connect } from 'react-redux'

import { personsRepresentativesTableChange } from './actions'

const mapStateToProps = (state, hocProps) => ({
    data: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'representatives',
        'data',
    ]),
    isLoading: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'representatives',
        'isLoading',
    ]),
    pagination: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'representatives',
        'pagination',
    ]),
    sorted: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'representatives',
        'sorted',
    ]),
    filter: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'representatives',
        'filter',
    ]),
})

export default connect(mapStateToProps, { personsRepresentativesTableChange })
